if (!customElements.get('wk-product-gallery')) {
  customElements.define(
    'wk-product-gallery',
    class extends HTMLElement {
      connectedCallback() {
        this.list = this.querySelector('.wk-product-gallery__list');
        this.slides = Array.from(this.querySelectorAll('.wk-product-gallery__slide'));
        this.thumbnails = Array.from(this.querySelectorAll('.wk-product-gallery__thumbnail'));
        this.dots = Array.from(this.querySelectorAll('.wk-product-gallery__dot'));

        this.thumbnails.forEach((thumbnail) => {
          thumbnail.addEventListener('click', () => {
            this.goTo(Number(thumbnail.dataset.index));
            thumbnail.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          });
        });
        this.dots.forEach((dot) => {
          dot.addEventListener('click', () => this.goTo(Number(dot.dataset.index)));
        });

        if (this.list) {
          this.list.addEventListener('scroll', () => this.onScroll(), { passive: true });
        }
      }

      goTo(index) {
        const slide = this.slides[index];
        if (!slide || !this.list) return;
        this.list.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
        this.setActive(index);
      }

      onScroll() {
        if (this.scrollTimeout) clearTimeout(this.scrollTimeout);
        this.scrollTimeout = setTimeout(() => {
          const scrollLeft = this.list.scrollLeft;
          let closestIndex = 0;
          let closestDistance = Infinity;
          this.slides.forEach((slide, index) => {
            const distance = Math.abs(slide.offsetLeft - scrollLeft);
            if (distance < closestDistance) {
              closestDistance = distance;
              closestIndex = index;
            }
          });
          this.setActive(closestIndex);
        }, 30);
      }

      setActive(index) {
        this.slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
        this.thumbnails.forEach((thumbnail, i) => thumbnail.classList.toggle('is-active', i === index));
        this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
      }
    }
  );
}
